var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsentWithdrawn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.737 65.737",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.869.9C15.213.9.9 15.213.9 32.869s14.313 31.968 31.969 31.968S64.837 50.525 64.837 32.87 50.525.9 32.87.9zm18.23 13.739c9.432 9.432 9.932 24.144 2.058 34.142l-36.201-36.2c10.002-7.877 24.712-7.373 34.143 2.058zm-36.46 36.46c-9.433-9.433-9.932-24.145-2.058-34.143l36.2 36.2C38.78 61.034 24.07 60.53 14.64 51.1z",
    fill: "#FE9F1D",
    fillRule: "nonzero",
    stroke: "#3C3C3B",
    strokeWidth: 1.8
  })));
}
export default SvgConsentWithdrawn;